// E-mail devolvido (bounce) no convite de assinatura do Autentique.
//
// Mora em _shared/ porque dois lados precisam da mesma leitura: a
// reconciliação do distrato (edge, Deno), que avisa quem emitiu, e a tela de
// emissão (CancelUCModal), que avisa antes de mandar de novo para o mesmo
// endereço. Mesmo padrão de analiseTecnicaConsumo.ts.
//
// Por que existe: em 17/09/2026, 16 de 86 distratos de inadimplência tiveram o
// e-mail do cliente devolvido, e ninguém no VigorHub ficava sabendo. Somando
// todos os documentos, 18 devoluções eram reenvio para um endereço que já
// tinha voltado antes.

/** Minúsculas e sem espaços — é como o Autentique devolve o e-mail. */
export function normalizarEmail(email: string | null | undefined): string {
  return (email || '').trim().toLowerCase();
}

/**
 * E-mail da própria Vigor no campo do cliente. O convite de assinatura DO
 * CLIENTE cairia numa caixa nossa — alguém de casa conseguiria assinar por ele.
 * Aconteceu em 16/09/2026 com `vigor@vigorenergy.com` (sem o `.br`).
 */
export function ehEmailDaVigor(email: string | null | undefined): boolean {
  return /@vigorenergy\.com(\.br)?$/.test(normalizarEmail(email));
}

/**
 * Motivo da devolução em linguagem de gente. O `reason` do Autentique é a
 * resposta crua do servidor (`550 5.1.1 ...`), ilegível para quem emite.
 *
 * A ordem importa: "caixa cheia" vem antes de "não existe" porque algumas
 * mensagens de cota também trazem `5.2.2`/`550`.
 */
export function motivoDevolucaoLegivel(reason: string | null | undefined): string {
  const r = (reason || '').toLowerCase();
  if (!r.trim()) return 'o servidor de e-mail do cliente recusou a entrega';
  if (/quota|storage space|mailbox full|caixa.*cheia/.test(r)) {
    return 'a caixa de entrada do cliente está cheia';
  }
  if (/mx info|ptr record|unrecognized address|domain not found|host not found|nxdomain/.test(r)) {
    return 'o domínio do e-mail não existe (provável erro de digitação)';
  }
  if (/5\.1\.1|5\.1\.10|nosuchuser|does not exist|user unknown|recipientnotfound|not found by smtp|mailbox unavailable/.test(r)) {
    return 'esse endereço de e-mail não existe';
  }
  if (/5\.4\.1|access denied/.test(r)) {
    return 'o servidor de e-mail do cliente recusou o endereço';
  }
  if (/spam/.test(r)) {
    return 'o servidor do cliente tratou o e-mail como spam';
  }
  if (/timeout|dial tcp|connection refused|deferred/.test(r)) {
    return 'o servidor de e-mail do cliente não respondeu';
  }
  return 'o servidor de e-mail do cliente recusou a entrega';
}

/**
 * `email_events` do Autentique vem como "2026-09-16 09:28:01": horário de
 * Brasília, SEM fuso. Gravado assim num timestamptz, o banco lê como UTC e a
 * devolução fica 3h fora. Conferido em 17/09/2026: documento criado às
 * 12:27Z tem `sent` "09:27". O Brasil não tem horário de verão desde 2019.
 */
export function instanteBrasilia(valor: string | null | undefined): string | null {
  if (!valor) return null;
  const m = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})$/.exec(valor.trim());
  return m ? `${m[1]}T${m[2]}-03:00` : valor;
}
